import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { initializeFirebaseAuth } from "./HelloCashflowDomain/Authentication/services/firebase";
import { initAuthStoreSync } from "./lib/firebase/authStoreSync";
import { store } from "./store/store";

// Initialize Firebase using the shared library's dependency injection system
initializeFirebaseAuth();
// Initialize the Auth <-> Store sync (moved out of lib/firebase.ts to avoid circular deps)
initAuthStoreSync();

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
);
